import { createStore } from 'vuex';

import accounts from './modules/accounts';
import agentBots from './modules/agentBots';
import agentCapacityPolicies from './modules/agentCapacityPolicies';
import agents from './modules/agents';
import assignmentPolicies from './modules/assignmentPolicies';
import articles from './modules/helpCenterArticles';
import attributes from './modules/attributes';
import auditlogs from './modules/auditlogs';
import auth from './modules/auth';
import automations from './modules/automations';
import bulkActions from './modules/bulkActions';
import campaigns from './modules/campaigns';
import cannedResponse from './modules/cannedResponse';
import categories from './modules/helpCenterCategories';
import contactConversations from './modules/contactConversations';
import contactLabels from './modules/contactLabels';
import contactNotes from './modules/contactNotes';
import contacts from './modules/contacts';
import conversationLabels from './modules/conversationLabels';
import conversationMetadata from './modules/conversationMetadata';
import conversationPage from './modules/conversationPage';
import conversations from './modules/conversations';
import conversationSearch from './modules/conversationSearch';
import conversationStats from './modules/conversationStats';
import conversationTypingStatus from './modules/conversationTypingStatus';
import conversationUnreadCounts from './modules/conversationUnreadCounts';
import conversationWatchers from './modules/conversationWatchers';
import csat from './modules/csat';
import customRole from './modules/customRole';
import customViews from './modules/customViews';
import dashboardApps from './modules/dashboardApps';
import draftMessages from './modules/draftMessages';
import globalConfig from 'shared/store/globalConfig';
import inboxAssignableAgents from './modules/inboxAssignableAgents';
import inboxes from './modules/inboxes';
import inboxMembers from './modules/inboxMembers';
import integrations from './modules/integrations';
import labels from './modules/labels';
import macros from './modules/macros';
import notifications from './modules/notifications';
import portals from './modules/helpCenterPortals';
import reports from './modules/reports';
import sla from './modules/sla';
import slaReports from './modules/SLAReports';
import sidebarSortPreferences from './modules/sidebarSortPreferences';
import summaryReports from './modules/summaryReports';
import teamMembers from './modules/teamMembers';
import teams from './modules/teams';
import userNotificationSettings from './modules/userNotificationSettings';
import webhooks from './modules/webhooks';
import * as pipelineStores from './modules/pipelines'; // MODULO PIPELINE/CRM - STORES
import subscription from './modules/pipelines/subscription'; // MODULO PIPELINE/CRM - SUBSCRIPTION STORE
import subscriptionLimits from './modules/pipelines/subscriptionLimits'; // MODULO PIPELINE/CRM - SUBSCRIPTION LIMITS STORE
import contactScores from './modules/pipelines/contactScores'; // MODULO PIPELINE/CRM - CONTACT SCORES STORE
import contactEvents from './modules/pipelines/contactEvents'; // MODULO PIPELINE/CRM - CONTACT EVENTS STORE
import orders from './modules/pipelines/orders'; // MODULO PIPELINE/CRM - ORDERS STORE
import carts from './modules/pipelines/carts'; // MODULO PIPELINE/CRM - CARTS STORE
import internalChat from './modules/internalChat'; // MODULO CHAT INTERNO
import internalChatTypingStatus from './modules/internalChat/typingStatus'; // MODULO CHAT INTERNO
import brain from './modules/pipelines/brain'; // MODULO BRAIN - AUTO-INJETADO
import captainAgentSessions from './captain/agentSessions';
import captainAssistants from './captain/assistant';
import captainDocuments from './captain/document';
import captainResponses from './captain/response';
import captainFaqSuggestions from './captain/faqSuggestions';
import captainInboxes from './captain/inboxes';
import captainBulkActions from './captain/bulkActions';
import copilotThreads from './captain/copilotThreads';
import copilotMessages from './captain/copilotMessages';
import captainScenarios from './captain/scenarios';
import captainTools from './captain/tools';
import captainCustomTools from './captain/customTools';

const plugins = [];

export default createStore({
  modules: {
    brain, // MODULO BRAIN - AUTO-INJETADO
    internalChat, // MODULO CHAT INTERNO
    internalChatTypingStatus, // MODULO CHAT INTERNO
    carts, // MODULO PIPELINE/CRM - CARTS STORE
    orders, // MODULO PIPELINE/CRM - ORDERS STORE
    contactEvents, // MODULO PIPELINE/CRM - CONTACT EVENTS STORE
    contactScores, // MODULO PIPELINE/CRM - CONTACT SCORES STORE
    subscriptionLimits, // MODULO PIPELINE/CRM - SUBSCRIPTION LIMITS STORE
    subscription, // MODULO PIPELINE/CRM - SUBSCRIPTION STORE
    ...pipelineStores, // MODULO PIPELINE/CRM - STORES
    accounts,
    agentBots,
    agentCapacityPolicies,
    agents,
    assignmentPolicies,
    articles,
    attributes,
    auditlogs,
    auth,
    automations,
    bulkActions,
    campaigns,
    cannedResponse,
    categories,
    contactConversations,
    contactLabels,
    contactNotes,
    contacts,
    conversationLabels,
    conversationMetadata,
    conversationPage,
    conversations,
    conversationSearch,
    conversationStats,
    conversationTypingStatus,
    conversationUnreadCounts,
    conversationWatchers,
    csat,
    customRole,
    customViews,
    dashboardApps,
    draftMessages,
    globalConfig,
    inboxAssignableAgents,
    inboxes,
    inboxMembers,
    integrations,
    labels,
    macros,
    notifications,
    portals,
    reports,
    sla,
    slaReports,
    sidebarSortPreferences,
    summaryReports,
    teamMembers,
    teams,
    userNotificationSettings,
    webhooks,
    captainAgentSessions,
    captainAssistants,
    captainDocuments,
    captainResponses,
    captainFaqSuggestions,
    captainInboxes,
    captainBulkActions,
    copilotThreads,
    copilotMessages,
    captainScenarios,
    captainTools,
    captainCustomTools,
  },
  plugins,
});
